import {
  anInsightEntityActivity,
  mockRelatedEntitiesCountQueryQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockRelatedEntitiesCountQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightEntityActivity: [anInsightEntityActivity()],
        },
      });
    }
  ),
];
